"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _Select = _interopRequireDefault(require("../Select"));

var _Caption = _interopRequireDefault(require("../Caption"));

var _LanguageForm = _interopRequireDefault(require("../forms/LanguageForm"));

var _redux = require("../../redux");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var LanguageSettings = function LanguageSettings(props) {
  var _site$languages, _site$languages$langu, _site$languages2, _site$languages2$lang;

  var fields = props.fields;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      site = _ref.cms.site;

  var dispatch = (0, _redux.useAppDispatch)();
  var languages = site === null || site === void 0 ? void 0 : site.languages;

  var _ref2 = (0, _react.useState)((languages === null || languages === void 0 ? void 0 : languages.postTypes) || []),
      _ref3 = _slicedToArray(_ref2, 2),
      postTypes = _ref3[0],
      setPostTypes = _ref3[1];

  var _ref4 = (0, _react.useState)((languages === null || languages === void 0 ? void 0 : languages.taxonomies) || []),
      _ref5 = _slicedToArray(_ref4, 2),
      taxonomies = _ref5[0],
      setTaxonomies = _ref5[1];

  var _ref6 = (0, _react.useState)((languages === null || languages === void 0 ? void 0 : languages.defaultLanguage) || ''),
      _ref7 = _slicedToArray(_ref6, 2),
      defaultLanguage = _ref7[0],
      setDefaultLanguage = _ref7[1];

  var _ref8 = (0, _react.useState)({
    action: '',
    payload: ''
  }),
      _ref9 = _slicedToArray(_ref8, 2),
      loading = _ref9[0],
      setLoading = _ref9[1];

  (0, _react.useEffect)(function () {
    // Update default language (changes when first language is added or current default language gets deleted)
    setDefaultLanguage((languages === null || languages === void 0 ? void 0 : languages.defaultLanguage) || '');
  }, [languages === null || languages === void 0 ? void 0 : languages.defaultLanguage]);

  var handleUpdate = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$dispatch, payload;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading({
                action: 'update-settings',
                payload: ''
              });
              _context.next = 3;
              return dispatch(_redux.languageActions.updateLanguageSettings({
                defaultLanguage: defaultLanguage,
                postTypes: postTypes,
                taxonomies: taxonomies
              }));

            case 3:
              _yield$dispatch = _context.sent;
              payload = _yield$dispatch.payload;

              if (payload) {
                _antd.message.success('Updated successfully');
              }

              setLoading({
                action: '',
                payload: ''
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleUpdate() {
      return _ref10.apply(this, arguments);
    };
  }();

  var handleOpenForm = /*#__PURE__*/function () {
    var _handleOpenForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var language,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              language = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
              dispatch(_redux.uiActions.showDialog({
                open: true,
                title: !!(language !== null && language !== void 0 && language.id) ? 'Edit' : 'Add',
                component: /*#__PURE__*/_react.default.createElement(_LanguageForm.default, {
                  language: language
                })
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function handleOpenForm() {
      return _handleOpenForm.apply(this, arguments);
    }

    return handleOpenForm;
  }();

  var handleDeleteLanguage = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(language) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading({
                payload: language.id,
                action: 'delete-language'
              });
              _context3.next = 3;
              return dispatch(_redux.languageActions.deleteLanguage(language));

            case 3:
              setLoading({
                action: '',
                payload: ''
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDeleteLanguage(_x) {
      return _ref11.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 40
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Languages",
    extra: [/*#__PURE__*/_react.default.createElement(_antd.Button, {
      key: "add-language",
      type: "primary",
      onClick: handleOpenForm,
      children: "Add"
    })]
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    pagination: false,
    dataSource: (site === null || site === void 0 ? void 0 : (_site$languages = site.languages) === null || _site$languages === void 0 ? void 0 : (_site$languages$langu = _site$languages.languages) === null || _site$languages$langu === void 0 ? void 0 : _site$languages$langu.map(function (o) {
      return _objectSpread(_objectSpread({}, o), {}, {
        key: o.id
      });
    })) || []
  }, /*#__PURE__*/_react.default.createElement(_antd.Table.Column, {
    title: "Flag",
    dataIndex: "flag",
    key: "flag",
    render: function render(img) {
      return img && (0, _htmlReactParser.default)(img);
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Table.Column, {
    title: "Name",
    dataIndex: "name",
    key: "name",
    width: "100%"
  }), /*#__PURE__*/_react.default.createElement(_antd.Table.Column, {
    title: "Locale",
    dataIndex: "locale",
    key: "locale"
  }), /*#__PURE__*/_react.default.createElement(_antd.Table.Column, {
    title: "Code",
    dataIndex: "slug",
    key: "slug"
  }), /*#__PURE__*/_react.default.createElement(_antd.Table.Column, {
    title: "Action",
    key: "action",
    render: function render(text, language) {
      return /*#__PURE__*/_react.default.createElement(_antd.Space, {
        key: language.id
      }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
        children: "Edit",
        onClick: function onClick() {
          return handleOpenForm(language);
        },
        type: "primary"
      }), /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
        title: "Are you sure?",
        onConfirm: function onConfirm() {
          return handleDeleteLanguage(language);
        },
        okText: "Yes",
        okButtonProps: {
          id: 'delete-media-confirm'
        },
        cancelText: "No"
      }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
        id: "delete-language",
        children: "Delete",
        danger: true,
        loading: (loading === null || loading === void 0 ? void 0 : loading.action) === 'delete-language' && (loading === null || loading === void 0 ? void 0 : loading.payload) === language.id
      })));
    }
  }))), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Settings"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 30
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Default Language",
    value: defaultLanguage,
    onChange: function onChange(value) {
      return setDefaultLanguage(value);
    }
  }, site === null || site === void 0 ? void 0 : (_site$languages2 = site.languages) === null || _site$languages2 === void 0 ? void 0 : (_site$languages2$lang = _site$languages2.languages) === null || _site$languages2$lang === void 0 ? void 0 : _site$languages2$lang.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: o.slug,
      value: o.slug,
      children: o.name
    });
  })), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Post Types"
  }), /*#__PURE__*/_react.default.createElement(_antd.Checkbox.Group, {
    options: Object.values(site === null || site === void 0 ? void 0 : site.postTypes).filter(function (o) {
      return !!(fields !== null && fields !== void 0 && fields.postTypes[o.id]);
    }).map(function (o) {
      return {
        value: o.id,
        label: o.title,
        disabled: o.id === 'page' || o.id === 'post'
      };
    }),
    defaultValue: postTypes,
    onChange: function onChange(values) {
      return setPostTypes(values);
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Taxonomies"
  }), /*#__PURE__*/_react.default.createElement(_antd.Checkbox.Group, {
    options: Object.values(site === null || site === void 0 ? void 0 : site.taxonomies).filter(function (o) {
      return !!(fields !== null && fields !== void 0 && fields.taxonomies.find(function (p) {
        return p.id === o.id;
      }));
    }).map(function (o) {
      return {
        value: o.id,
        label: o.title,
        disabled: o.id === 'category' || o.id === 'post_tag'
      };
    }),
    defaultValue: taxonomies,
    onChange: function onChange(values) {
      return setTaxonomies(values);
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "URL modifications"
  }), /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, {
    onChange: function onChange() {},
    value: 'directory'
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: 'directory'
  }, "Directory: https://test.com/en/my-post/"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: 'subdomain',
    disabled: true
  }, "Subdomains: https://en.test.com/my-post/"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: 'different-domains',
    disabled: true
  }, "Different domains")))), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    onClick: handleUpdate,
    children: "Update",
    type: "primary",
    loading: (loading === null || loading === void 0 ? void 0 : loading.action) === 'update-settings'
  }))));
};

var _default = LanguageSettings;
exports.default = _default;